import React, { useState } from "react";
import Modal from './modal'
import Select from "react-select";
import { useTranslation } from "react-i18next";

import { selectStyles } from "./styles";
import { ExercisesList } from "../../pages/exercises/index";
import { ActionsList } from "../../pages/actions/index";
import { VariationsList } from "../../pages/exercise_collections/index";
import { PracticeTemplateList } from "../../pages/practice_templates/index"

function LibraryDialog({ close, onChange, libraries = ['Aktion', 'Exercise', 'PracticeTemplates', 'ExerciseCollection'] }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  const [library, setLibrary] = useState({ value: libraries[0], label: t(`shared.${libraries[0]}`)});

  return (
    <Modal openModal={show} closeModal={() => close ? close() : setShow(false)}>
      <div className="custom-dialog-content"> 
      {libraries.length > 1 && <div className="flex1 flex-column">
        <div className="heading">{t('shared.select')}</div>
        <Select
          styles={selectStyles}
          closeMenuOnSelect={true}
          options={libraries.map(item => ({ value: item, label: t(`shared.${item}`)}))}
          isSearchable={false}
          onChange={setLibrary}
          value={library}
        />
      </div>}
      {library?.value === 'Exercise' && <ExercisesList select={(item) => onChange("Exercise", item)} />}
      {library?.value === 'Aktion' && <ActionsList select={(item) => onChange("Aktion", item)} />}
      {library?.value === 'ExerciseCollection' && <VariationsList select={(item) => onChange("ExerciseCollection", item)} />}
      {library?.value === 'PracticeTemplates' && <PracticeTemplateList select={(item) => onChange("PracticeTemplates", item)}/>}
      </div>
    </Modal>)

}

export default LibraryDialog;